import React, { useContext, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import * as myconst from "../../constants"
import { getConversationData, getUsersData } from 'services/coversationService';
import { handleLoader, handleNotFound, setStopId } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { Controller, useForm } from 'react-hook-form';
import { Chats, CloseBlack, NoRecord, Users } from 'assets/icons';
import Conversation from 'components/ai-chat-board/Conversation';
import { handleActive } from 'redux/persistentSlice';
import { getBase64OfSheet } from 'services/userService';
import StateContext from 'constants/StateContext';

interface fullname_dropdown {
    fullname: string;
    username: string;
}
interface users_type {
    users_list: fullname_dropdown[],
    total_users_count: number,
    total_conversations_count: number
}
interface conversation_type {
    conversation_id: string,
    title: string,
    created_at: string,
    update_time: string
}

interface conversation_list_type {
    total_conversation_count: number,
    conversations: conversation_type[]
}
interface City {
    name: string;
    code: string;
}

interface date_filter {
    from_date: string | null
    to_date: string | null
    client_env: string | null
    users_list?: string[]
}
interface filtered_data_type {
    datesArr: Date[],
    selected_user: City[] | undefined
}

interface form_data_type {
    dates: Date[],
    selectedUsers: City[]
}

interface conversation_data_filter {
    start_date: string,
    end_date: string,
    user_name: string,
    offset: number,
    limit: number,
    client_env: string | null
}

interface Query {
    que: string;
    isUser: boolean;
}

interface Answer {
    que: string;
    ans: {
        response: {
            output_text: string;
        };
        isFirst: boolean;
    };
}
interface date_sheet {
    start_date: string
    end_date: string
    users_list: string[]
    user_name: string | null,
    client_env: string | null
}
interface StateContextType {
    userQuery: Query[];
    setUserQuery: React.Dispatch<React.SetStateAction<Query[]>>;
    setAnswer: React.Dispatch<React.SetStateAction<Answer[]>>;
    answer: Answer[];
    handleGetConversation: (id: string, username: string | null) => void;
}

const ConversationHistory = () => {
    const { userQuery, setUserQuery, setAnswer, answer, handleGetConversation } = useContext<StateContextType>(StateContext);
    const {
        handleSubmit,
        setValue,
        control,
        setError,
        clearErrors,
        getValues,
        trigger,
        watch,
        formState: { errors },
    } = useForm<any>()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const targetRef = useRef<HTMLDivElement>(null);
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const stateWise = location.state || {};
    const conversationID: string | null = searchParams.get('conversation_id');
    const [userList, setUserList] = useState<users_type>({
        users_list: [{ fullname: '', username: 'meet.patel@rysun.com' }],
        total_users_count: 0,
        total_conversations_count: 0
    });
    const [page, setPage] = useState<number>(5);
    const [conversationList, setConversationList] = useState<conversation_list_type>({
        conversations: [],
        total_conversation_count: 0
    });
    const [activeAccordion, setActiveAccordion] = useState<string | null>(stateWise.user_name);
    const [activeDP, setActiveDP] = useState<string | null>(stateWise.full_name);
    const [activeconversationID, setActiveConversationID] = useState<string | null>(conversationID);
    const [filterActive, setFilterActive] = useState<boolean>(false);
    const [userClick, setUserClick] = useState<boolean>(false);
    const dates = watch('dates');
    const selectedUsers = watch('selectedUsers');
    const [filterUserList, setFilterUserList] = useState<users_type>({
        users_list: [],
        total_users_count: 0,
        total_conversations_count: 0
    });
    const [filterUserListTemp, setFilterUserListTemp] = useState<users_type>({
        users_list: [],
        total_users_count: 0,
        total_conversations_count: 0
    });
    const [filteredData, setFilteredData] = useState<filtered_data_type>({
        datesArr: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
        selected_user: [],
    })
    const notify = (toastmsg: string) => {
        return toast(toastmsg, {
            position: 'bottom-center',
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }

        });
    };

    const handleDisable = () => {
        const startDate = myconst.formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        const endDate = myconst.formateDate(new Date())
        if (dates !== undefined && selectedUsers !== undefined) {
            if (myconst.formateDate(dates[0]) === startDate && myconst.formateDate(dates[1]) === endDate && selectedUsers.length === 0) {
                return true
            } else {
                return false
            }
        }
    }

    const getUserData = async (dates: Date[], isDefault: string, userArr: City[] | undefined) => {
        dispatch(handleLoader(true));
        let data: date_filter = {
            from_date: '',
            to_date: '',
            client_env: localStorage.getItem('clientName')
            // users_list: []
        };
        data.from_date = myconst.formateDate(dates[0])
        data.to_date = myconst.formateDate(dates[1])
        if ((isDefault === 'filter' || isDefault === 'params') && userArr?.length !== 0) {
            data.users_list = userArr?.map((username: City) => username.code)
        }
        try {
            const { result, error } = await getUsersData(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (result?.users_list.length === 0) {
                setUserQuery([]);
                setAnswer([]);
                navigate(`/admin/conversation-history?start_date=${myconst.formateDate(dates[0])}&end_date=${myconst.formateDate(dates[1])}`)
            }
            if (isDefault === 'default') {
                setUserList(result)
                setFilterUserList(result);
                setFilterUserListTemp(result);
                await handleCondition(result, isDefault, userArr);
            } else {
                setUserList(result);
                await handleCondition(result, isDefault, userArr)
            }
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const userDataForFilter = async (dates: (Date | null)[], text: string) => {
        dispatch(handleLoader(true));
        let data: date_filter = {
            from_date: '',
            to_date: '',
            client_env: localStorage.getItem('clientName')
        };
        if (dates[0] !== null && dates[1] !== null) {
            data.from_date = myconst.formateDate(dates[0])
            data.to_date = myconst.formateDate(dates[1])
        }
        try {
            const { result, error } = await getUsersData(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (text === 'params' || text === 'reset') {
                setFilterUserListTemp(result);
            }
            setFilterUserList(result);
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getConversationDataByUsername = async (username: string | null, text: string, userData: users_type, userArr: City[] | undefined) => {
        dispatch(handleLoader(true));
        setPage(5);
        let data: conversation_data_filter = {
            start_date: '',
            end_date: '',
            user_name: username !== null ? username : '',
            offset: 0,
            limit: 5,
            client_env: localStorage.getItem('clientName')
        };
        const tempDate = getValues('dates')
        if (text === 'params') {
            data.start_date = stateWise?.start_date
            data.end_date = stateWise?.end_date
        } else {
            data.start_date = myconst.formateDate(tempDate[0])
            data.end_date = myconst.formateDate(tempDate[1])
        }
        try {
            const { result, error } = await getConversationData(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setConversationList(result);
            if (text === 'default') {
                const state = {
                    start_date: myconst.formateDate(tempDate[0]),
                    end_date: myconst.formateDate(tempDate[1]),
                    user_name: userData.users_list[0].username,
                    full_name: userData.users_list[0].fullname,
                    user_array: stateWise.user_array !== undefined ? stateWise.user_array : [],
                };
                navigate(`/admin/conversation-history?conversation_id=${result.conversations[0].conversation_id}`, { replace: true, state })
                await handleGetConversation(result.conversations[0].conversation_id, username);
                setActiveConversationID(result.conversations[0].conversation_id)
            } else if (text === 'filter') {
                const state = {
                    start_date: myconst.formateDate(tempDate[0]),
                    end_date: myconst.formateDate(tempDate[1]),
                    user_name: userData.users_list[0].username,
                    full_name: userData.users_list[0].fullname,
                    user_array: userArr !== undefined && userArr?.length > 0 ? userArr : [],
                };
                navigate(`/admin/conversation-history?conversation_id=${result.conversations[0].conversation_id}`, {
                    state
                })
                await handleGetConversation(result.conversations[0].conversation_id, username);
                setActiveConversationID(result.conversations[0].conversation_id)
            } else if (text === 'params' && conversationID !== null && username !== null) {
                await handleGetConversation(conversationID, username);
                await userDataForFilter([new Date(stateWise?.start_date), new Date(stateWise?.end_date)], 'params')
                // setFilterUserListTemp(filterUserList);
                setFilteredData({
                    datesArr: [new Date(stateWise?.start_date), new Date(stateWise?.end_date)],
                    selected_user: userArr
                })
                setActiveConversationID(conversationID)
            }
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getConversationDataByUsernameScroll = async (username: string | null) => {
        dispatch(handleLoader(true));
        let data: conversation_data_filter = {
            start_date: myconst.formateDate(dates[0]),
            end_date: myconst.formateDate(dates[1]),
            user_name: username !== null ? username : '',
            offset: page,
            limit: 5,
            client_env: localStorage.getItem('clientName')
        };
        try {
            const { result, error } = await getConversationData(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setConversationList((prevState) => ({
                total_conversation_count: result.total_conversation_count,
                conversations: [...prevState.conversations, ...result.conversations],
            }));
            setPage((prevPage) => prevPage + 5);
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    useEffect(() => {
        if (stateWise?.start_date === undefined && stateWise?.end_date === undefined) {
            setUserClick(true);
            setValue('dates', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()])
            setValue('selectedUsers', []);
            getUserData([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()], 'default', []);
        } else if (stateWise?.start_date !== undefined && stateWise?.end_date !== undefined) {
            setValue("dates", [new Date(stateWise?.start_date), new Date(stateWise?.end_date)]);
            setValue('selectedUsers', stateWise.user_array !== undefined ? stateWise.user_array : []);
        }
    }, []);

    useEffect(() => {
        window.onpopstate = e => {
            setUserClick(false);
        };
    });
    useEffect(() => {
        if (stateWise?.start_date !== undefined && stateWise?.end_date !== undefined && !userClick) {
            setValue("dates", [new Date(stateWise?.start_date), new Date(stateWise?.end_date)]);
            setValue('selectedUsers', stateWise.user_array !== undefined ? stateWise.user_array : []);
            getUserData([new Date(stateWise?.start_date), new Date(stateWise?.end_date)], 'params', stateWise.user_array !== undefined ? stateWise.user_array : []);
        }
    }, [userClick, conversationID, stateWise])


    const handleCondition = async (result: users_type, isDefault: string, userArr: City[] | undefined) => {
        if (result?.users_list.length > 0) {
            if (isDefault !== 'params') {
                setActiveAccordion(result?.users_list[0]?.username);
                setActiveDP(result?.users_list[0]?.fullname);
                await getConversationDataByUsername(result?.users_list[0].username, isDefault, result, userArr);
            } else {
                setActiveAccordion(stateWise.user_name);
                setActiveDP(stateWise.full_name);
                await getConversationDataByUsername(stateWise.user_name, isDefault, result, userArr);
            }
        }
    }

    const onSubmit = async (data: form_data_type) => {
        if (data.dates && data.dates[0] !== null && data.dates[1] === null) {
            setError('dates', { type: 'custom', message: "Please select end date also", });
        } else {
            setFilterActive(false)
            setUserClick(true);
            setFilterUserListTemp(filterUserList);
            setFilteredData({
                datesArr: data.dates,
                selected_user: data?.selectedUsers
            })
            getUserData(data.dates, 'filter', data?.selectedUsers)
        }
    }
    const handleReset = async () => {
        setValue('dates', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()])
        setValue('selectedUsers', []);
        await getUserData([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()], 'default', []);
    }
    const handleResetFilter = async () => {
        clearErrors('dates');
        setValue('dates', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()])
        setValue('selectedUsers', []);
        await userDataForFilter([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()], 'reset')
    }

    useEffect(() => {
        if (targetRef.current && answer.length > 0) {
            const elementPosition = targetRef.current.getBoundingClientRect().top; // Element's position relative to viewport
            const offset = 70; // Define your desired offset
            const scrollPosition = window.pageYOffset + elementPosition - offset; // Calculate the scroll position with offset

            window.scrollTo({
                top: scrollPosition,
                behavior: "smooth", // Smooth scrolling
            });
        }
    }, [answer])
    useEffect(() => {
        dispatch(handleNotFound(false));
    }, [])

    const AccordionScroll: React.FC = () => {
        useEffect(() => {
            const accordions = document.querySelectorAll('.accordion-collapse');

            const handleScroll = (event: Event) => {
                const target = event.target as HTMLElement;
                const heading = target.previousElementSibling as HTMLElement;

                // Adjust scroll to ensure heading is visible
                if (heading) {
                    if (window.innerWidth < 768) {
                        const offset = 60; // Adjust this value as needed
                        const headingPosition = heading.getBoundingClientRect().top + window.pageYOffset;

                        // Scroll to the heading with an offset
                        window.scrollTo({
                            top: headingPosition - offset,
                            behavior: "smooth", // Add smooth scrolling effect
                        });
                    } else {
                        heading.scrollIntoView({ block: 'start' });
                    }

                }
            };

            accordions.forEach((accordion) => {
                accordion.addEventListener('shown.bs.collapse', handleScroll);
            });

            return () => {
                accordions.forEach((accordion) => {
                    accordion.removeEventListener('shown.bs.collapse', handleScroll);
                });
            };
        }, [activeAccordion]);

        return null;
    };
    const downloadCSV = async () => {
        try {
            dispatch(handleLoader(true));
            const tempDate: Date[] = getValues('dates')
            let data: date_sheet = {
                start_date: myconst.formateDate(tempDate[0]),
                end_date: myconst.formateDate(tempDate[1]),
                users_list: selectedUsers?.map((username: City) => username.code),
                user_name: localStorage.getItem('username'),
                client_env: localStorage.getItem('clientName')
            };
            const { result, error } = await getBase64OfSheet(data);
            if (error || result?.error) {
                throw error || result.error;
            }
            dispatch(handleLoader(false));
            if (result.data !== 'No data found for the specified date range.') {
                await myconst.downloadBase64FileO(result.data)
            }

        } catch (error: unknown) {
            dispatch(handleLoader(false));
            const message = error instanceof Error ? error.message : "Unknown error";
            toast.error(message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    return (
        <div className='content-wrapper p-4'>
            <div className="user-management-section">
                <div className='d-flex flex-wrap'>
                    <div className='qmate-sidebar'>
                        <div className='qmate-header'>
                            <strong>{!filterActive ? 'Conversation List' : 'Filter'}</strong>
                            {!filterActive ?
                                <span>
                                    <i className='pi pi-filter mr-4' title='Filter' onClick={() => setFilterActive(true)}>{!handleDisable() && <span className='active-filter'></span>}</i>
                                    <i className={`pi pi-download ${userList.users_list.length === 0 ? 'disable-icon' : ''}`} title='Download User Chat History' onClick={() => {
                                        if (userList.users_list.length > 0) {
                                            downloadCSV()
                                        }
                                    }}></i>
                                </span>
                                :
                                <i onClick={() => { clearErrors('dates'); setFilterActive(false); setValue('dates', filteredData.datesArr); setValue('selectedUsers', filteredData.selected_user); setFilterUserList(filterUserListTemp) }}><img src={CloseBlack} alt="Close Icon" /></i>
                            }
                        </div>
                        {!filterActive ?
                            <>
                                <div className='qmate-user-chat'>
                                    <ul>
                                        <li>
                                            <i><img src={Users} alt="Users" /></i><span>Users</span>
                                            <strong>{userList?.total_users_count.toLocaleString("en-US", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })}</strong>
                                        </li>
                                        <li>
                                            <i><img src={Chats} alt="Chats" /></i><span>Chats</span>
                                            <strong>{userList?.total_conversations_count.toLocaleString("en-US", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })}</strong>
                                        </li>
                                    </ul>
                                </div>
                                <div className="accordion" id="accordionExample">
                                    <AccordionScroll />
                                    {userList.users_list?.map((user: fullname_dropdown, index: number) => (
                                        <div className="accordion-item" key={index} >
                                            <h2 className="accordion-header" onClick={() => {
                                                if (user.username !== activeAccordion) {
                                                    getConversationDataByUsername(user.username, 'click', userList, []);
                                                    setActiveAccordion(user?.username);
                                                    // setActiveDP(user?.fullname);
                                                }
                                            }} id={`heading${index}`}>
                                                <button
                                                    className={`accordion-button ${user?.username !== activeAccordion ? "collapsed" : ""}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded={user?.username === activeAccordion ? "true" : "false"}
                                                    aria-controls={`collapse${index}`}
                                                >
                                                    <span>{user?.fullname}</span>
                                                </button>
                                            </h2>
                                            <div
                                                id={`collapse${index}`}
                                                className={`accordion-collapse collapse ${user?.username === activeAccordion ? "show" : ""}`}
                                                aria-labelledby={`heading${index}`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <ul className="accordion-body">
                                                    {conversationList?.conversations?.map((con: conversation_type) => (
                                                        <li role="button" className={activeconversationID === con?.conversation_id ? 'active' : ''} key={con?.conversation_id} onClick={() => {
                                                            const tempDate = getValues('dates');
                                                            setUserClick(true);
                                                            const state = {
                                                                start_date: myconst.formateDate(tempDate[0]),
                                                                end_date: myconst.formateDate(tempDate[1]),
                                                                user_name: user.username,
                                                                full_name: user.fullname,
                                                                user_array: stateWise.user_array !== undefined ? stateWise.user_array : [],
                                                            };
                                                            navigate(`/admin/conversation-history?conversation_id=${con?.conversation_id}`, { state })
                                                            handleGetConversation(con?.conversation_id, user.username);
                                                            setActiveConversationID(con?.conversation_id)
                                                            setActiveDP(user?.fullname)
                                                        }}>
                                                            <strong title={con?.title}>{con?.title}</strong>
                                                            <p>{moment(con?.update_time?.replace("+00:00", '')
                                                            ).format(
                                                                'MMM DD YYYY, HH:mm:ss'
                                                            )}</p>
                                                        </li>
                                                    ))}
                                                    {conversationList?.total_conversation_count > page &&
                                                        <div className='p-3 d-flex justify-content-center'>
                                                            <span className="link-btn c-pointer" onClick={() => getConversationDataByUsernameScroll(user?.username)}>View More</span>
                                                        </div>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                            :
                            <>
                                <div className='add-filter'>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="filter-col">
                                            <label htmlFor="date" className="form-label">Select Date</label>
                                            <div className='filter-wrap'>
                                                <Controller
                                                    name="dates" // Specify the field name
                                                    control={control}
                                                    defaultValue={null} // Set the initial value as needed
                                                    rules={{
                                                        validate: {
                                                            required: (value) => value && value.length === 2 || "Both start and end dates are required",
                                                            endDateRequired: (value) => value && value[1] !== null || "Please select end date also",
                                                        }
                                                    }} // Add validation rules here
                                                    // rules={{ required: "Date is required" }} // Add validation rules here
                                                    render={({ field: { onBlur, onChange, value } }) => (
                                                        <Calendar
                                                            maxDate={new Date()}
                                                            value={value}
                                                            onChange={async (e) => {
                                                                onChange(e.value)
                                                                await trigger("dates")
                                                                if (e.value && e.value.length === 2) {
                                                                    if (e.value[1] === null) {
                                                                        setError('dates', { type: 'custom', message: "Please select end date also", });
                                                                    } else {
                                                                        clearErrors('dates');
                                                                        setFilterUserListTemp(filterUserList);
                                                                        setValue('selectedUsers', []);
                                                                        await userDataForFilter(e.value, 'calander');
                                                                    }
                                                                }
                                                            }}
                                                            selectionMode="range"
                                                            readOnlyInput
                                                            showIcon
                                                            hideOnRangeSelection
                                                            className="user-input table-search"
                                                        />
                                                    )}
                                                />
                                                {errors.dates && <p className="text-danger mb-0" style={{fontSize: '14px'}}>{errors.dates.message as any}</p>}
                                            </div>
                                        </div>
                                        <div className="filter-col">
                                            <label htmlFor="date" className="form-label">Select User</label>
                                            <div className='filter-wrap'>
                                                <Controller
                                                    name="selectedUsers"
                                                    control={control}
                                                    defaultValue={[]}
                                                    render={({ field }) => (
                                                        <MultiSelect
                                                            value={field.value}
                                                            onChange={(e) => field.onChange(e.value)}
                                                            options={filterUserList?.users_list?.map((user: fullname_dropdown) => ({ name: user?.fullname, code: user?.username }))}
                                                            optionLabel="name"
                                                            filter
                                                            placeholder="Search Users"
                                                            maxSelectedLabels={3}
                                                            resetFilterOnHide={true}
                                                            panelClassName="conversation-filter"
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="filter-col">
                                            <div className="action-btn-wrap">
                                                <Button disabled={handleDisable()} onClick={handleResetFilter} type="button" className="grey-outline-btn btn-lg">Reset</Button>
                                                <Button className="outline-active-btn btn-lg" type="submit">Apply</Button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </>
                        }
                    </div>
                    <div className={`qmate-admin ${userList.users_list.length === 0 ? 'no-record' : ''}`} ref={targetRef}>
                        {userList.users_list.length === 0 ?
                            <div className='no-record-wrap'>
                                <img className="feedback-dislike-icon" src={NoRecord} alt="dislike" />
                                <h1>No conversations found</h1>
                                <p>No results match the selected filter criteria. Remove or clear all filters to see results.</p>
                                <Button onClick={handleReset}>Clear All Filters</Button>
                            </div> :
                            <>
                                <div className='d-flex align-items-center flex-wrap' >
                                    {answer.length > 0 && userQuery.length > 0 &&
                                        <h4 className="mb-0">Conversation History</h4>
                                    }
                                </div>
                                <Conversation
                                    notify={notify}
                                    component={'history'}
                                    activeDP={activeDP}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConversationHistory